<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 mb-3 text-left">Customer Reviews Information</h3>

            <p class="explanation-text mb-3">
                {{ customer_data.customer_nickname }} clicks the link in the text message and lands on a branded webpage with
                her contact information, asking her to review it for accuracy.
            </p>

            <ul class="explanation-points">
                <li
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                    class="explanation-point"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="explanation-text">{{ point }}</p>
                </li>
            </ul>
        </div>

        <div class="primary-note">
            <v-icon
                color="info"
                size="20"
                aria-hidden="true"
                left
            >
                mdi-information
            </v-icon>
            <span>
                This natural touchpoint provides an opportunity to establish consent while
                Maria is already engaged with confirming/updating her information.
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        explanation_points() {
            const nickname = this.customer_data?.customer_nickname || 'The customer';
            return [
                `${nickname} reviews each field and can edit any information that needs updating`,
                `At the bottom, there are required checkboxes to confirm that each field is accurate, followed by an optional text consent checkbox`,
                `If ${nickname} checks the consent box, written consent is captured; if left unchecked, no consent is recorded`
            ];
        }
    }
}
</script>

<style lang="scss" scoped></style>
